import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography, Hidden } from "@material-ui/core";
import PropTypes from "prop-types";
import { useHistory, Link } from "react-router-dom";

// Custom components
import PointSchedulerDialog from "../PointSchedulerDialog";

// API
import { listSchedulePoints } from "../../api/Points";
import { Skeleton } from "@material-ui/lab";

/**
 * Styles
 */
const useStyles = makeStyles(() => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    maxHeight: "390px",
    whiteSpace: "nowrap",
  },
}));

function ClientSheduler(propts) {
  const classes = useStyles();
  const history = useHistory();
  const [schedule_points, setSchedulePoints] = useState([]);

  const getSchedulePoints = () => {
    listSchedulePoints(propts.client_id).then((result) => {
      setSchedulePoints(result.data.queueWorkers);
    });
  };

  // Get schedule_points when client_id changes
  useEffect(() => {
    let isMounted = true;
    listSchedulePoints(propts.client_id).then((result) => {
      if (isMounted) {
        setSchedulePoints(result.data.queueWorkers);
      }
      return () => {
        isMounted = false;
      };
    });
  }, [propts.client_id]);

  return (
    <div>
      <Paper className={classes.paper}>
        {propts.loading ? (
          // Skeleton
          <Grid container spacing={2}>
            {/* Title */}
            <Grid id="grid_title" xs={12} item sm={6} md={6}>
              <Skeleton height={41.6} />
            </Grid>
            {/* Schedule points button */}
            <Grid id="grid_button" item xs={12} sm={6} md={6}>
              <Hidden smUp>
                <Skeleton height={36} />
              </Hidden>
              <Hidden xsDown>
                <Grid container alignItems="center" justify="flex-end">
                  <Skeleton height={36} width={138.25} />
                </Grid>
              </Hidden>
            </Grid>
            {/* Render entries */}
            {[1, 2].map((item, index) => {
              return (
                <Grid key={index} item xs={12} sm={6}>
                  <Skeleton height={32} width="50%" />
                  <Skeleton height={29.6} width="25%" />
                  <Skeleton height={29.6} width="75%" />
                  <Skeleton height={29.6} width="50%" />
                  {/* Delete button */}
                  <Grid container justify={"flex-end"}>
                    <Skeleton height={36} width="25%" />
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        ) : (
          // Container
          <Grid container spacing={2}>
            {/* Title */}
            <Grid id="grid_title" xs={12} item sm={6} md={6}>
              <Typography variant="h4">Point Manager</Typography>
            </Grid>
            {/* Schedule points button */}
            <Grid id="grid_button" item xs={12} sm={6} md={6}>
              <Hidden smUp>
                <PointSchedulerDialog
                  openButtonFullWidth
                  division_categories={propts.division_categories}
                  setError={propts.setError}
                  getSchedulePoints={getSchedulePoints}
                  client_id={Number(propts.client_id)}
                />
              </Hidden>
              <Hidden xsDown>
                <Grid container alignItems="center" justify="flex-end">
                  <PointSchedulerDialog
                    division_categories={propts.division_categories}
                    setError={propts.setError}
                    getSchedulePoints={getSchedulePoints}
                    client_id={Number(propts.client_id)}
                  />
                </Grid>
              </Hidden>
            </Grid>
            <Grid
              id="grid_title"
              xs={12}
              item
              sm={12}
              md={12}
              style={{ textAlign: "right" }}
            >
              <Link
                href="#"
                variant="body2"
                onClick={() => {
                  history.push(`/app/client/${propts.client_id}/points_log`);
                }}
              >
                <Typography>VIEW LOG</Typography>
              </Link>
            </Grid>

            {/* Schedule points headers*/}
            <Grid container spacing={2}>
              <Grid item xs={2} md={2} lg={2}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ paddingLeft: "10px" }}
                >
                  POINTS
                </Typography>
              </Grid>
              <Grid item xs={3} md={3} lg={3}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ paddingLeft: "10px" }}
                >
                  DIVISION
                </Typography>
              </Grid>
              <Grid item xs={3} md={3} lg={3}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ paddingLeft: "10px" }}
                >
                  REPEAT
                </Typography>
              </Grid>
              <Grid item xs={3} md={3} lg={3}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ paddingLeft: "10px" }}
                >
                  DATE
                </Typography>
              </Grid>
              <Grid item xs={1} md={1} lg={1}></Grid>
            </Grid>

            {/* Schedule points List */}
            <Grid
              container
              style={{
                maxHeight: 280,
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {schedule_points.length > 0 ? (
                schedule_points.map((points, index) => {
                  let division_category = propts.division_categories.find(
                    (dc) => dc.id == points.JsonData.DivisionCategoryId
                  );
                  return (
                    <Grid key={index} container spacing={1}>
                      <Grid item xs={2} md={2} lg={2}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                        >
                          {points.JsonData.Points}
                        </Typography>
                      </Grid>
                      <Grid item xs={3} md={3} lg={3}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                          noWrap
                        >
                          {division_category ? division_category.Name : "ALL"}
                        </Typography>
                      </Grid>
                      <Grid item xs={3} md={3} lg={3}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                        >
                          {points.RepeatType
                            ? points.RepeatType
                            : "No repetition"}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} md={2} lg={2}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                        >
                          {new Date(points.Start).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          })}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} md={2} lg={2}>
                        <PointSchedulerDialog
                          openButtonFullWidth
                          division_categories={propts.division_categories}
                          setError={propts.setError}
                          getSchedulePoints={getSchedulePoints}
                          client_id={Number(propts.client_id)}
                          leverType="label"
                          scheduleForEdit={points}
                        />
                      </Grid>
                    </Grid>
                  );
                })
              ) : (
                <Grid item xs={12}>
                  <Typography variant="h5">No points scheduled</Typography>
                </Grid>
              )}
            </Grid>

            
          </Grid>
        )}
      </Paper>
    </div>
  );
}

ClientSheduler.propTypes = {
  contact_user: PropTypes.object,
  loading: PropTypes.bool,
};

export default ClientSheduler;
